import type { Registry as Services } from '@ember/service';
import { type Variance, VARIANCES } from 'lumen/utils/constants/variance';

interface FormatVarianceOptions {
  isValuePercent: boolean;
  varianceType: Variance;
}

/**
 * Formats a market snapshots variance as a whole number with its sign:
 * "+6%" for percentage, "+4 pt" for absolute on a percent value
 * (e.g. occupancy), and "+12" for any other absolute value.
 */
export function formatVariance(
  intl: Services['intl'],
  variance: number,
  { isValuePercent, varianceType }: FormatVarianceOptions,
): string {
  if (varianceType === VARIANCES.PERCENTAGE) {
    return intl.formatNumber(variance, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      signDisplay: 'exceptZero',
      style: 'percent',
    });
  }

  // Manual scaling for percentage point differences (e.g. 0.04 → +4 pt)
  if (varianceType === VARIANCES.ABSOLUTE && isValuePercent) {
    const formatted = intl.formatNumber(variance * 100, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      signDisplay: 'exceptZero',
    });

    return intl.t('general.percentage_point', { count: formatted });
  }

  return intl.formatNumber(variance, {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    signDisplay: 'exceptZero',
  });
}
